import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_3 = {
  class: "modal",
  style: {"width":"800px"}
}
const _hoisted_4 = { class: "modal__header modal__header--success" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "clipboard__header--title" }, "Pixel activation", -1)
const _hoisted_6 = { class: "modal__content" }
const _hoisted_7 = { class: "clipboard--help__desk pa--top-1 pa--bottom-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clipboard--help__desk--count" }, "1", -1)
const _hoisted_9 = { class: "clipboard--help__desk--content" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clipboard--help__desk--content__text" }, " Copy this pixel code: ", -1)
const _hoisted_11 = { class: "clipboard--help__desk--content__input" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "color--primary-green text--weight-bold text--align-center"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"clipboard--help__desk pa--y-2\"><div class=\"clipboard--help__desk--count\">2</div><div class=\"clipboard--help__desk--content__text\"> Place the copied code on your website before the end of the body tag. </div></div><div class=\"clipboard--help__desk pa--y-2\"><div class=\"clipboard--help__desk--count\">3</div><div class=\"clipboard--help__desk--content__text\"> Once your pixel is placed correctly, you&#39;ll receive a confirmation email and site will be activated </div></div>", 2)
const _hoisted_17 = { class: "clipboard--help__desk pa--y-2 align--baseline" }
const _hoisted_18 = { class: "form-field form-field__outline ma--x-1" }
const _hoisted_19 = { class: "form-field__outline--control" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "site-url",
  class: "form-field__outline--control__label"
}, "Email", -1)
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "clipboard--help__desk pa--y-2" }
const _hoisted_23 = { class: "form-checkbox" }
const _hoisted_24 = { for: "termsAndConditions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_clipboard = _resolveDirective("clipboard")!
  const _directive_outline = _resolveDirective("outline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("a", {
          class: "fa fa-times clipboard__header--clear",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearPixel && _ctx.clearPixel(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.termsAndConditions ? 'clipboard--help__desk--content__input--pixelbox' : 'clipboard--help__desk--content__input--msg')
              }, [
                (_ctx.termsAndConditions)
                  ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                      key: 0,
                      style: {"border":"none"},
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pixelCode) = $event)),
                      rows: "15",
                      cols: "65"
                    }, null, 512)), [
                      [_vModelText, _ctx.pixelCode]
                    ])
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "btn btn--primary",
          style: {"width":"-webkit-fill-available"},
          disabled: !_ctx.termsAndConditions
        }, [
          _createTextVNode(" Copy ")
        ], 8, _hoisted_12)), [
          [_directive_clipboard, _ctx.pixelCode, "copy"],
          [_directive_clipboard, _ctx.copyClipboard, "success"]
        ]),
        _hoisted_13,
        (_ctx.userAlert)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.userMessage), 1))
          : _createCommentVNode("", true),
        _hoisted_15,
        _createElementVNode("div", _hoisted_17, [
          _createTextVNode(" Email to developer - "),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-field__outline--control__input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.request.email) = $event)),
                style: {"width":"400px"}
              }, null, 512), [
                [_vModelText, _ctx.request.email],
                [_directive_outline]
              ]),
              _hoisted_20
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn--primary",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendMail && _ctx.sendMail(...args))),
            disabled: !_ctx.termsAndConditions
          }, " Send ", 8, _hoisted_21)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _withDirectives(_createElementVNode("input", {
              id: "termsAndConditions",
              type: "checkbox",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.termsAndConditions) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.termsAndConditions]
            ]),
            _createElementVNode("label", _hoisted_24, "I hereby agree to all Terms and Conditions associated with using the " + _toDisplayString(_ctx.appName) + " Dashboard.", 1)
          ])
        ])
      ])
    ])
  ]))
}